/**
 * ExtractFromVideo controller
 * Add/Edit Season TV Shows
 */

/**
 * ExtractFromVideo controller
 *
 * @class ExtractFromVideo
 * @memberof mwApp/seasons
 * @see mwApp/seasons
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/seasons.controller:ExtractFromVideo
 */
/* @ngInject */
export default function ExtractFromVideo (
  $http,
  $scope,
  $uibModalInstance,
  Entity,
  alertLiteSvc,
  playbackTokenGenerators
) {
  const vm = this
  vm.playbackTokenGenerators = playbackTokenGenerators
  vm.playbackURL = ''
  vm.tokenGeneratorId = ''
  vm.tokenGeneratorIdRequired = false
  vm.posters = []
  vm.poster = {}

  vm.baseUrl = 'api/frame-extractor-tasks'
  vm.task = {}

  vm.errors = {
    MASTER_PLAYLIST_FORBIDDEN: 'Playback URL is protected.',
    MASTER_PLAYLIST_GENERAL_ERROR: 'Invalid Playback URL.',
    TRICKPLAY_PLAYLIST_NOT_FOUND: 'Playlist must contain trickplay variant.'
  }
  vm.showErrors = true

  /**
   * Load table data for Smart Table
   *
   * @memberof mwApp/seasons.controller:ExtractFromVideo
   * @param {Object} tableState - Smart Table state object
   * @return {Promise} Promise that resolves to object with content array
   */
  vm.loadTable = function (tableState) {
    const pageSize = tableState.pagination.number || 25
    const page = Math.floor(tableState.pagination.start / pageSize)

    vm.task.loading = true

    return $http.get(`${vm.baseUrl}/${vm.task.id}`, { params: { page } })
      .data()
      .then((response) => response.payload)
      .then((response) => {
        tableState.pagination.numberOfPages = response.totalPages || 0

        vm.posters = response.urls
      })
      .catch(alertLiteSvc.alertError)
      .finally(() => {
        vm.task.loading = false
      })
  }

  vm.placeNewTask = function () {
    vm.task.status = ''
    vm.posters = []
    vm.showErrors = false
    vm.poster = {}

    const params = { url: vm.playbackURL }
    if (vm.tokenGeneratorId) {
      params.pbtId = vm.tokenGeneratorId
    }

    vm.task.loading = true

    return $http.post(vm.baseUrl, { ...params })
      .data()
      .then((response) => response.payload)
      .then((response) => {
        vm.task.id = response.taskId
        vm.task.status = response.status
        vm.task.errorCode = response.errorCode

        return response
      })
      .catch(alertLiteSvc.alertError)
      .finally(() => {
        vm.task.loading = false
        vm.showErrors = true
      })
  }

  vm.setPoster = function (poster) {
    vm.posters.forEach(p => { p.chosen = false })
    poster.chosen = true
    vm.poster = poster
  }

  vm.submit = function () {
    $uibModalInstance.close(vm.poster)
  }

  vm.close = function () {
    $uibModalInstance.dismiss()
  }
}
